"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
/**
 * Resets Ordered List Numbering back to the value of the parameter startNumber
 * @param editor The editor instance
 * @param separator The HTML element that indicates when to split the VList
 * @param startNumber The number of that the splitted list should start
 */
function setOrderedListNumbering(editor, separator, startNumber) {
    if (startNumber === void 0) { startNumber = 1; }
    editor.addUndoSnapshot(function () {
        editor.focus();
        var regions = editor.getSelectedRegions();
        if (regions[0]) {
            var vList = roosterjs_editor_dom_1.createVListFromRegion(regions[0], false /*includeSiblingLists*/, separator);
            if (vList) {
                vList.split(separator, startNumber);
                vList.writeBack();
            }
        }
    }, "Format" /* Format */);
}
exports.default = setOrderedListNumbering;
//# sourceMappingURL=setOrderedListNumbering.js.map